export default function (value){
    console.log(value)
}